import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import App from './app/App';
import constants from 'constants';
import loadGoogleMapsAPI from 'load-google-maps-api';
import { QueryClient, QueryClientProvider } from 'react-query';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 2,
        },
    },
});

let render;

loadGoogleMapsAPI({
    key: constants.GOOGLE_MAP_API_KEY,
    libraries: ['drawing', 'geometry'],
    v: '3.64',
}).then(() => {
    render = (Component) => {
        ReactDOM.render(
            <AppContainer>
                <QueryClientProvider client={queryClient}>
                    <Component />
                </QueryClientProvider>
            </AppContainer>,
            document.getElementById('root'),
        );
    };

    render(App);
});

if (module.hot) {
    module.hot.accept('./app/App', () => {
        render(App);
    });
}



// WEBPACK FOOTER //
// ./main.js